module.exports = __webpack_public_path__ + "static/img/satanizador-2.211a5fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/satanizador-2.jpg
// module id = 52nB
// module chunks = 1